import { FC } from 'react';

interface TermsOfServiceModalProps {
  title: string;
  contents: string;
  agreeButtonText: string;
  // 正在把同意送給後端；此時按鈕鎖住，避免連點送出兩次。
  isSubmitting: boolean;
  // 送出同意失敗時要顯示的訊息；沒有錯誤時為 null。
  errorMessage: string | null;
  onAgree: () => void;
}

/**
 * 服務條款彈窗。純顯示元件：收到什麼就畫什麼，不知道資料從哪裡來。
 *
 * 刻意沒有任何關閉的入口 —— 沒有關閉鈕、點背景不關、按 Esc 也不關。
 * 唯一的出口是同意按鈕。
 */
const TermsOfServiceModal: FC<TermsOfServiceModalProps> = ({
  title,
  contents,
  agreeButtonText,
  isSubmitting,
  errorMessage,
  onAgree,
}) => (
  <div className="terms-of-service-popup" role="dialog" aria-modal="true" aria-label={title}>
    <div className="terms-of-service-popup__header">
      <h2 className="terms-of-service-popup__title">{title}</h2>
    </div>

    {/* 標記這個屬性，底層頁面被鎖住捲動時，這一區仍然可以自己捲。 */}
    <div className="terms-of-service-popup__content" body-scroll-lock-ignore="true">
      <p>{contents}</p>
    </div>

    <div className="terms-of-service-popup__footer">
      {errorMessage && <p className="terms-of-service-popup__error">{errorMessage}</p>}
      <button
        type="button"
        className="terms-of-service-popup__agree-button"
        disabled={isSubmitting}
        onClick={onAgree}
      >
        {agreeButtonText}
      </button>
    </div>
  </div>
);

export default TermsOfServiceModal;
